import moment from 'moment';
import {drawPickingLabel, drawLocationLabel, drawBinningLabel} from './labels';

const download = (filename, text) => {
  const element = document.createElement('a');
  element.setAttribute(
    'href',
    `data:text/plain;charset=utf-8, ${encodeURIComponent(text)}`
  );
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const pickingLabelsPrint = (labels, quantityLabelsToCut) => {
  let zpl = '';
  let invertedLabel = false;
  let count = 1;

  labels.forEach((label) => {
    zpl += drawPickingLabel(label, invertedLabel);
    if (count % quantityLabelsToCut === 0) {
      invertedLabel = !invertedLabel;
    }
    count++;
  });

  const fileName = `temslabels${moment().unix()}.txt`;
  download(fileName, zpl);
};


export const printLocationLabels = (locations) => {
  let labelsCode = '';

  locations.forEach((item) => {
    labelsCode += drawLocationLabel(item);
  });

  const printWindow = window.open();
  printWindow.document.open('text/plain');
  printWindow.document.write(`${labelsCode}`);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

export const printBinningLabels = (labels) => {
  const isPrintElement = document.getElementsByClassName('checking-label')[0];
  if (!isPrintElement) {
    const labelsToPrint = labels.map((label) => drawBinningLabel(label));
    const element = document.createElement('div');
    element.className = 'checking-label';
    element.innerHTML = labelsToPrint.join('');
    document.body.appendChild(element);
    window.print();
    setTimeout(() => element.remove(), 500);
  }
};
